module.exports = __webpack_public_path__ + "img/020-iraq.25630bd4.svg";